import React, { useEffect, useRef } from 'react'
import './Tomilogos.scss'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Tomilogos = () => {
    const sectionRef = useRef(null);
    const cardRefs = useRef([]);
  
    useEffect(() => {
      const cards = cardRefs.current;
  
      const initialPositions = [
        { x: 0, y: 100, opacity: 0 },
        { x: 0, y: 150, opacity: 0 },
        { x: 0, y: 200, opacity: 0 },
      ];
  
      cards.forEach((card, index) => {
        gsap.fromTo(
          card,
          initialPositions[index], 
          {
            x: 0,
            y: 0,
            opacity: 1,
            duration: 1,
            ease: "power3.out",
            scrollTrigger: {
              trigger: card,
              start: "top 100%",
              toggleActions: "play none none none",
            //   markers: true
            },
          }
        );
  
        gsap.set(card, { transformOrigin: "center" });
  
        card.addEventListener("mouseenter", () => {
          gsap.to(card, { scale: 1, duration: 0.3 });
        });
  
        card.addEventListener("mouseleave", () => {
          gsap.to(card, { scale: 1, duration: 0.3 });
        });
      });
    }, []);
    return (
        <>
            <section className='Tomilogoprnt'>
                <div className="custom-container" ref={sectionRef}>
                    <div className="tomilogoschldmain">
                        <div className="tomilogoheader">

                            <div className="lefttomilogosheader">
                                <h2>1. TOMI Logo</h2>
                                <p>Tomi logos and logo guide in .png and .svg format.</p>
                            </div>
                            <a className='lefttomilogosheaderbtn secondarybtn' href='\Tomi-Logos.zip'>Download Logo</a>
                        </div>
                        <div className="tomilogochld">
                            <div className="tomilogoone" ref={(el) => (cardRefs.current[0] = el)}>
                                <div className="tomilogosss">
                                    <img className='img-fluid' src="/assets/Brandguidline/tomilogo1.png" alt="tomilogoimg" />
                                </div>
                                <p>Full logo (Vertical)</p>
                            </div>
                            <div className="tomilogoone" ref={(el) => (cardRefs.current[1] = el)}>
                                <div className="tomilogosss">
                                    <img className='img-fluid' src="/assets/Brandguidline/tomilogo2.png" alt="tomipixelwideimg" />
                                </div>
                                <p>Full logo (Vertical)</p>
                            </div>
                            <div className="tomilogoone" ref={(el) => (cardRefs.current[2] = el)}>
                                <div className="tomilogosss">
                                    <img className='img-fluid' src="/assets/Brandguidline/tomilogo3.png" alt="tomifulllogo" />
                                </div>
                                <p>Full logo (Vertical)</p>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

        </>
    )
}

export default Tomilogos